import * as React from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';
import ChevronDownIcon from 'lucide-react/dist/esm/icons/chevron-down';

export default function DesktopFeaturesMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-1 px-3 py-2 rounded-full transition-all duration-300 hover:bg-gray-100 text-joey-navy">
        Features
        <ChevronDownIcon className="inline" size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-white border border-gray-200 shadow-lg rounded-lg p-2 mt-2 min-w-[280px] z-50">
        <DropdownMenuItem asChild>
          <Link to="/features/iphone-monitoring" className="flex items-center px-3 py-2 text-joey-navy hover:bg-gray-100 rounded cursor-pointer w-full">
            iPhone & iMessage Monitoring
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/features/hows-my-child-report" className="flex items-center px-3 py-2 text-joey-navy hover:bg-gray-100 rounded cursor-pointer w-full">
            How's My Child? Report
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/features/smart-alerts" className="flex items-center px-3 py-2 text-joey-navy hover:bg-gray-100 rounded cursor-pointer w-full">
            Smart Alerts
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/features/contact-verification" className="flex items-center px-3 py-2 text-joey-navy hover:bg-gray-100 rounded cursor-pointer w-full">
            Contact Verification
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/features/analytics" className="flex items-center px-3 py-2 text-joey-navy hover:bg-gray-100 rounded cursor-pointer w-full">
            Analytics
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}